import React from "react"
import Style from "@/components/ProductDetail/v3/SuperSkuOption/index.module.scss"

const SuperSkuOptionButton = props => {
  const { option, isActive, disabled, onClick } = props

  const selectedClass = isActive
    ? Style.activeBttn
    : disabled
    ? Style.disabledBttn
    : ""

  const classButton = `${Style.superSkuOptionButton} ${selectedClass} `

  return (
    <button
      disabled={disabled}
      className={classButton}
      onClick={() => onClick(option)}
    >
      {option}
    </button>
  )
}

export default SuperSkuOptionButton
